import './App.scss';

import Card from './ui/Card'
import CompHeading from './components/Heading/'
import CompLogo from './components/Logo/'
import CompTitle from './components/Title/'
import CompMap from './components/Map/'
import CompCloud from './components/Cloud'
import ClientLogo from './components/ClientLogo'
import { themes } from './utilities'

// ZERO Data Visualization Web Components
import './data-viz/components/HelpButton'
import './data-viz/components/SimpleMetric'
import './data-viz/components/Gauge'
import './data-viz/components/PercentOf'
import './data-viz/components/MetricBreakdown'
import './data-viz/components/Comparison'

export default function App() {
    const hrrData = [
        {
            id: '102',
            val: 20
        },

        {
            id: 106,
            val: 400
        },

        {
            id: 300,
            val: 460
        },

        {
            id: 1,
            val: 300
        },

        {
            id: 19,
            val: 627
        },

        {
            id: 103,
            val: 210
        },

        {
            id: 107,
            val: 466
        },

        {
            id: 340,
            val: 78
        },

        {
            id: 339,
            val: 491
        },

        {
            id: 293,
            val: 120
        },

        {
            id: 201,
            val: 333
        }
    ]

    const marketData = { 
        primary: [
            104,
            155,
            171,
            339
        ],

        legend: [
            {
                color: 'raspberry',
                label: 'Primary Market'
            },
        
            {
                color: 'white',
                label: 'Secondary Market'
            }
        ]
    }

    const sampleTotal = 45600
    
    return (
        <div>
            <h1 style={{
                textAlign: 'center', 
                marginTop: '3em'
            }}>ZERO Sigma Plugins</h1>

            <p style={{
                textAlign: 'center',
                margin: 'auto',
                maxWidth: '80rem'
            }}>A gallery of all currently available custom plugins for use in Sigma. Each plugin is fully-scalable and will resize to the space allotted.</p>
        
            <section className='grid gutter col-3 gap-sm stretch'>
                <Card fullwidth={true} title="Titled Header" path="titled-header">
                    <header className='header' style={{
                        display: 'grid',
                        alignItems: 'center',
                        gap: '2em',
                        gridTemplateColumns: '11.5rem 1fr auto',
                        padding: '0 var(--gap-sm)'
                    }}>
                        <CompLogo />
                        <CompTitle txt='Report Name'/>
                        
                        <h3
                        style={{
                            margin: 0,
                            textAlign: 'right'
                        }}>Astoria, Inc.</h3>
                    </header>
                </Card>

                <Card title="Metric Card (with or w/o trend line)" path="card">
                    <zero-simple-metric
                        data-fill={themes['Cyan'].dark}
                        data-bg={themes['Cyan'].light}
                        data-value={sampleTotal}
                        data-label="Total Savings"
                        data-format="currency"
                        data-help="Some help text"
                        data-history="30000,76000,94000,41000,64000,46000,67000,101000,180000,150000,200100"
                        data-history-labels="May 2024,June 2024,July 2024,August 2024,September 2024,October 2024,November 2024,December 2024,January 2025,February 2025,March 2025"></zero-simple-metric>
                </Card>

                <Card title="1 to 1 Comparison Bar Chart" path="card">
                    <zero-comparison
                        data-fill="var(--color-3)"
                        data-fill2="var(--color-3-dk)"
                        data-bg="var(--color-3-lt)"
                        data-heading="Year-Over-Year Savings"
                        data-values="130500, 189650"
                        data-labels="2024, 2025"
                        data-format="currency"
                        data-help="Some help text"></zero-comparison>
                </Card>

                <Card title="Gauge" path="gauge">
                    <zero-gauge
                        data-value="0.23"
                        data-heading="Email Open Rate"
                        data-fill={themes['Raspberry'].dark}
                        data-bg={themes['Raspberry'].light}
                        data-help="Some help text"></zero-gauge>
                </Card>

                <Card title="Progress Chart" path="progress-chart">
                    <zero-percent-of
                        data-fill={themes['Orange Slice'].dark}
                        data-bg={themes['Orange Slice'].light}
                        data-value="45600"
                        data-total="120000"
                        data-heading="Realized Savings"
                        data-help="Some help text"></zero-percent-of>
                </Card>

                <Card title="PHA Interactions" path="interactions">
                    <zero-metric-breakdown
                        data-fill="var(--color-4-dk)"
                        data-bg="var(--color-4-lt)"
                        data-heading="PHA Interactions"
                        data-format="decimal"
                        data-values="300, 150, 50"
                        data-labels="Calls, Chats, Emails"
                        data-help="Some help text"></zero-metric-breakdown>
                </Card>

                <Card title="Heading" path="heading">
                    <CompHeading txt="A Sample Section Heading" color="blue-jeans"/>
                </Card>

                <Card title="U.S. Choropleth Map" path="choropleth">
                    <CompMap 
                        id="choropleth"
                        title='Choropleth Map'
                        type='hrr'
                        choropleth={hrrData}
                        color='raspberry'
                        />
                </Card>

                <Card title="Word Cloud" path="word-cloud">
                    <CompCloud 
                        string="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vestibulum, nunc a laoreet luctus, arcu odio vestibulum tortor, eget dignissim quam eros quis massa. Pellentesque et mattis arcu. Cras at massa sed elit faucibus fringilla. Sed justo leo, fermentum nec lectus et, gravida eleifend mauris. Integer egestas, mauris id aliquet mattis, arcu elit finibus massa, non sodales felis sapien sed eros. Aenean leo orci, efficitur vitae massa et, lobortis dapibus urna. Fusce a nunc imperdiet est rutrum maximus. Vestibulum venenatis at ipsum in congue. Praesent aliquet sit amet nulla vitae imperdiet. Nunc a ligula convallis, varius quam sit amet, auctor lectus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam nulla metus, eleifend sit amet ligula in, aliquam ultricies nibh. Donec rhoncus risus non nunc accumsan, et placerat nisi pretium. Proin commodo tortor velit. Donec eget semper nibh. Nulla pulvinar semper dapibus. Aliquam sed vestibulum quam. Proin at cursus velit, rhoncus efficitur arcu. Etiam velit orci, facilisis vitae ornare nec, congue quis quam. Ut commodo velit sollicitudin justo pellentesque, eget vehicula justo pellentesque. Quisque bibendum quis ipsum a consequat. Integer feugiat dolor id nulla convallis, et cursus dui pharetra. Nunc sem tortor, auctor at nunc vitae, euismod congue ante. Donec imperdiet justo vitae semper fringilla. Nullam id gravida quam, in scelerisque velit. Ut in nisl nec sem tempor porttitor. Fusce felis urna, consequat ut posuere bibendum, luctus a ex Sed enim sapien, mollis vitae elementum ut, consequat sit amet sapien. Maecenas purus tortor, dignissim sed magna in, accumsan placerat nunc. Cras lacinia nisi eget nisi fringilla, sit amet ultricies mauris vestibulum. Nam eu cursus tortor, quis laoreet augue. Morbi ultricies dictum rhoncus. In mollis dolor et lorem pulvinar, quis pulvinar metus pulvinar. Praesent nunc massa, aliquet sit amet vestibulum sollicitudin, elementum in nunc. Nulla ultrices lorem ac convallis molestie. Vestibulum consequat dui nec elit vehicula rutrum. Aliquam nisl turpis, faucibus id vestibulum sit amet, blandit non felis. Donec at leo nisl. Praesent ornare aliquam erat, at tempor nisi finibus suscipit. Suspendisse pretium nunc suscipit ligula auctor, scelerisque hendrerit nibh molestie. Etiam accumsan convallis eros, eget semper dui semper sed. Mauris molestie ullamcorper eros et sollicitudin. Nam lacinia augue luctus sodales fringilla. Morbi et ligula erat. Proin mattis tortor ut lacinia placerat. Nulla elit arcu, hendrerit vitae suscipit in, vestibulum pellentesque nisl. Vestibulum vel dolor nec neque iaculis consequat dapibus sit amet nisi. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Phasellus a diam eget purus interdum ultrices quis et risus. Donec nec lobortis sem. Morbi congue maximus nisl a posuere. Integer ornare lacus et nibh viverra, a tincidunt ligula lobortis. Ut eu sem ac mi sollicitudin tincidunt vel eu nibh. Etiam tincidunt ligula sit amet lobortis pharetra. Fusce cursus tempor velit id luctus. Etiam nunc velit, dictum vitae lectus sed, gravida ultrices lorem. Suspendisse mauris ex, pulvinar vel luctus sit amet, vehicula eu metus. Vestibulum blandit nulla in erat iaculis, eget pretium tellus lacinia. Proin nibh sapien, gravida eu tincidunt et, posuere sed nisl. Cras ornare vitae neque non molestie. Nulla arcu lectus, rhoncus in purus vitae, blandit volutpat enim. Nam velit mi, lacinia vitae condimentum et, varius ut sapien. Phasellus fermentum semper justo. Duis id enim at dui lobortis auctor a eget justo. Donec sollicitudin id diam sed mattis. Sed dolor tellus, pellentesque in condimentum ac, volutpat et turpis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Sed vitae massa quis mi blandit dapibus et ac tellus. Curabitur egestas sollicitudin gravida. Nulla eget ultrices diam. Mauris vel dui feugiat, feugiat eros ac, interdum mauris. Phasellus accumsan ornare est, quis cursus sapien hendrerit accumsan. Integer tempor mauris sed augue sagittis, porta auctor eros congue. Pellentesque non massa vitae tortor blandit pellentesque id vitae dolor."></CompCloud>
                </Card>

                <Card title="Logo Grid" path="logo-grid">
                    <section style={
                        {
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr',
                            gap: '4rem'
                        }
                    }>
                        <ClientLogo
                        src="logo.svg"
                        label="ZERO" />

                        <ClientLogo
                        src="logo.svg"
                        label="ZERO" />

                        <ClientLogo
                        src="logo.svg"
                        label="ZERO" />

                        <ClientLogo
                        src="logo.svg"
                        label="ZERO" />

                        <ClientLogo
                        src="logo.svg"
                        label="ZERO" />
                        
                        <ClientLogo
                        src="logo.svg"
                        label="ZERO" />

                        <ClientLogo
                        src="logo.svg"
                        label="ZERO" />

                        <ClientLogo
                        src="logo.svg"
                        label="ZERO" />
                        
                        <ClientLogo
                        src="logo.svg"
                        label="ZERO" />
                    </section>
                </Card>

                <Card title="Markets Map" path="markets">
                    <CompMap 
                        id="markets"
                        title='Markets Map'
                        type='hrr'
                        market={marketData}
                        />
                </Card>

                
            </section>
        </div>
    );
}
